import React, { useState, useEffect, Fragment } from "react";
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack, Alert, Collapse, FormControl, FormControlLabel } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useAuth0 } from "@auth0/auth0-react";
import CustomToolbar from "./Widgets/CustomToolbar";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SuccessError from "./Widgets/SuccessError";
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import moment from "moment";
import SelfSizingTextField from "./Widgets/selfSizingTextField";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';


var reRender = 1;

const useAsyncLoad = (url) => {

  const [errorA, setErrorA] = useState(null);
  const [loading, setLoading] = useState(true);
  const [incidents, setIncidents] = useState(null);


  const x = reRender;

  async function GetIncidentData(url) {

    const audience = 'https://piaapplication.azurewebsites.net/';

    // const accessToken = await getAccessTokenSilently({
    //   audience: audience,
    //   //scope: "read:messages",
    // });

    var bearer = localStorage.getItem("userToken");

    var incidentData = await fetch(url, {
      method: 'GET',
      withCredentials: true,
      credentials: 'include',
      headers: {
        'Authorization': bearer,
        'Content-Type': 'application/json'
      }
    });

    var data = await incidentData.json();

    data.accessToken = bearer;

    return data;

  };


  async function loadData(url) {

    try {

      setErrorA(null);
      if (x < 2) {
        setLoading(true);
      }

      var data = await GetIncidentData(url);

      setIncidents(data);

    } catch (e) {
      setLoading(false);
      setErrorA(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData(url);
    // eslint-disable-next-line
  }, [x]);


  return [incidents, errorA, loading];
}


const FetchIncidents = () => {
  const [value, error, loading] = useAsyncLoad("incidents/getincidents");

  return [value, error, loading];
}

export default function DataTable() {

  const [open, setOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [deleteName, setDeleteName] = React.useState('');
  const [deleteId, setDeleteId] = React.useState('');
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
  const [accessToken, setAccessToken] = useState();
  const [generalOpen, setGeneralOpen] = useState(true);
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [affectedNotified, setAffectedNotified] = useState(null);
  const [notificationStartDate, setNotificationStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [notificationEndDate, setNotificationEndDate] = useState(moment().format("YYYY-MM-DD"));
  // const UrlRe = RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');

  const validationSchema = Yup.object().shape({
    id: Yup.number(),
    incidentTitle: Yup.string()
      .required('Incident Title is required')
      .max(250, 'Incident Title must not exceed 150 characters'),
    institutionName: Yup.string()
      .required('Institution Name is required')
      .max(250, 'Institution Name must not exceed 15 characters'),
    institutionAddress: Yup.string()
      .required('Address is required')
      .max(500, 'Institution Address must not exceed 350 characters'),
    incidentDescriber: Yup.string()
      .max(250, 'Incident Describer must not exceed 250 characters'),
    describerTitle: Yup.string()
      .max(150, 'Title must not exceed 350 characters')
      .nullable(),
    contactPhone: Yup.string()
      .max(50, 'Phone not exceed 350 characters')
      .nullable(),
    contactMobile: Yup.string()
      .max(50, 'Phone not exceed 350 characters')
      .nullable(),
    totalAffected: Yup.number()
      .nullable()
      .typeError('Must be a number'),
    canadiansAffected: Yup.number()
      .nullable()
      .typeError('Must be a number'),
    startDate: Yup.date()
      .nullable()
      .typeError('Must be a valid date'),
    endDate: Yup.date()
      .nullable()
      .typeError('Must be a valid date'),
    organizationInvolved: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    howWhyOccured: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    whenDiscovered: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    whereOccurred: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    whoGainedAccess: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    infoBreachedDescription: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    affectedNotified: Yup.boolean()
      .nullable(),
    notificationStartDate: Yup.date()
      .nullable()
      .typeError('Must be a valid date'),
    notificationEndDate: Yup.date()
      .nullable()
      .typeError('Must be a valid date'),
    notificationMethod: Yup.string()
      .max(250, 'Cannot exceed 250 characters')
      .nullable(),
    notificatonDescription: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    notificationIndirectDescription: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    notificationStepsDescription: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    notifiedOrganizations: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),
    riskReductionSteps: Yup.string()
      .max(2500, 'Cannot exceed 2500 characters')
      .nullable(),

  });

  const onSubmit = data => {
    if (data.id === -1) {
      saveIncident(data, 'Add', accessToken);
    } else {
      saveIncident(data, 'Save', accessToken);
    }
    setOpen(false);
  };

  const showSuccess = message => {
    setSuccessOpen(true);
    setSuccessMessage(message);
    setTimeout(() => setSuccessOpen(false), 3000);
  };

  const showError = () => {
    setErrorOpen(true);
    setTimeout(() => setErrorOpen(false), 3000);
  };

  async function saveIncident(incident, saveOrAddOrDelete, accessToken) {
    //console.log(incident);
    var method = '';
    var url = ''
    if (saveOrAddOrDelete === 'Add') {
      method = 'POST';
      url = 'incidents/';
    } else if (saveOrAddOrDelete === 'Save') {
      method = 'PUT';
      url = 'incidents/' + incident.id;
    }
    else if (saveOrAddOrDelete === 'Delete') {
      method = 'DELETE';
      url = 'incidents/' + incident.id;
    }

    var bearer = localStorage.getItem("userToken");

    try {
      const requestOptions = {
        method: method,
        withCredentials: true,
        credentials: 'include',
        headers: {
          'Authorization': bearer,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(incident)
      };

      var result = await fetch(url, requestOptions);

      if (result.status === 500) {
        showError();
      } else {
        switch (saveOrAddOrDelete) {
          case 'Save':
            showSuccess("Update Successful");
            break;
          case 'Add':
            showSuccess("New record added successfully");
            break;
          case 'Delete':
            showSuccess("Record Deleted");
            break;
          default:
            showSuccess("Update Successful");
        }
      }
    } catch (e) {

      showError();
    } finally {
      reRender = reRender + 1;
      //console.log(reRender);
    }
  }

  const {
    register,
    control,
    setValue,
    getValues,
    handleSubmit,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const columns = [
    {
      field: "Actions", width: 150, sortable: false,
      disableExport: 'true',
      renderCell: (cellValues) => {
        return (

          <div>
            {/* {vendorData.userAndTenant.isSuperAdmin && */}
            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleClickOpen(event, cellValues, incidentData.accessToken);
              }}
            >
              <EditIcon />
            </Button>
            {/* } */}
            {//vendorData.userAndTenant.isSuperAdmin &&

              <Button
                variant="outlined"
                color="primary"
                onClick={(event) => {
                  handleDeleteOpen(event, cellValues);
                }}
              >
                <DeleteIcon />
              </Button>
            }
          </div>
        );
      }
    },
    { field: 'institutionName', headerName: 'Institution', width: 130 },
    { field: 'incidentTitle', headerName: 'Incident Title', minWidth: 130, flex: 1 },
    {
      field: 'startDate', headerName: 'Date', minWidth: 100, flex: 1,
      renderCell: (cellValues) => {
        return (

          [ moment(cellValues.row.startDate).format("DD-MM-YYYY")]
        );
      }
    },

  ];


  var returnData = FetchIncidents();
  var incidentData = returnData[0];
  //console.log(vendorData);

  if (incidentData && !accessToken) {

    setAccessToken(incidentData.accessToken);
  }

  var loading = returnData[2];
  var error = returnData[1];

  const handleClickOpen = (event, cellValues, accessToken) => {
    console.log(cellValues.row);
    var dataRow = cellValues.row;

    setValue("id", dataRow.id);
    //setIncidentId(dataRow.id);
    //setAccessToken(vendorData.accessToken);
    setValue("accessToken", accessToken);
    setValue("incidentTitle", dataRow.incidentTitle);
    setValue("institutionName", dataRow.institutionName);
    setValue("institutionAddress", dataRow.institutionAddress);
    setValue("incidentDescriber", dataRow.incidentDescriber);
    setValue("describerTitle", dataRow.describerTitle);
    setValue("contactMobile", dataRow.contactMobile);
    setValue("contactPhone", dataRow.contactPhone);
    setValue("totalAffected", dataRow.totalAffected);
    setValue("canadiansAffected", dataRow.canadiansAffected);
    setValue("startDate", dataRow.startDate);
    setStartDate(dataRow.startDate);
    setValue("endDate", dataRow.endDate);
    setEndDate(dataRow.endDate);
    setValue("organizationInvolved", dataRow.organizationInvolved);
    setValue("howWhyOccured", dataRow.howWhyOccured);
    setValue("whenDiscovered", dataRow.whenDiscovered);
    setValue("whereOccurred", dataRow.whereOccurred);
    setValue("whoGainedAccess", dataRow.whoGainedAccess);
    setValue("infoBreachedDescription", dataRow.infoBreachedDescription);
    setValue("affectedNotified", dataRow.affectedNotified);
    setAffectedNotified(dataRow.affectedNotified);
    setValue("notificationStartDate", dataRow.notificationStartDate);
    setNotificationStartDate(dataRow.notificationStartDate);
    setValue("notificationEndDate", dataRow.notificationEndDate);
    setNotificationEndDate(dataRow.notificationEndDate);
    setValue("notificationMethod", dataRow.notificationMethod);
    setValue("notificatonDescription", dataRow.notificatonDescription);
    setValue("notificationIndirectDescription", dataRow.notificationIndirectDescription);
    setValue("notificatonStepsDescription", dataRow.notificatonStepsDescription);
    setValue("notifiedOrganizations", dataRow.notifiedOrganizations);
    setValue("riskReductionSteps", dataRow.riskReductionSteps);

    setEditOrAddTitle('Edit');
    clearErrors();
    setOpen(true);

  };



  const addIncident = (event, cellValues) => {
    setValue("id", -1);
    setValue("incidentTitle", '');
    setValue("incidentTitle", '');
    setValue("institutionAddress", '');
    setValue("incidentDescriber", '');
    setValue("describerTitle", '');
    setValue("contactPhone", '');
    setValue("contactMobile", '');
    setValue("totalAffected", null);
    setValue("canadiansAffected", null);
    setValue("startDate", null);
    setStartDate(null);
    setValue("endDate", null);
    setEndDate(null);
    setValue("organizationInvolved", '');
    setValue("howWhyOccured", '');
    setValue("whenDiscovered", '');
    setValue("whereOccurred", '');
    setValue("whoGainedAccess", '');
    setValue("infoBreachedDescription", '');
    setValue("affectedNotified", false);
    setValue("notificationStartDate", null);
    setNotificationStartDate(null);
    setValue("notificationEndDate", null);
    setNotificationEndDate(null);
    setValue("notificationMethod", '');
    setValue("notificatonDescription", '');
    setValue("notificationIndirectDescription", '');
    setValue("notificatonStepsDescription", '');
    setValue("notifiedOrganizations", '');
    setValue("riskReductionSteps", '');

    setEditOrAddTitle('Add');
    clearErrors();
    setOpen(true);

  };


  const handleDeleteOpen = (event, cellValues) => {
    var dataRow = cellValues.row;
    setDeleteName(dataRow.name);
    setDeleteId(dataRow.id)
    setDeleteOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteOpen(false);
  };

  const handleDelete = () => {
    var data = { id: deleteId };
    // data.id = deleteId;
    saveIncident(data, 'Delete');
    reRender = reRender + 1;
    setDeleteOpen(false);
  };
  const closeSuccess = () => {
    setSuccessOpen(false);
  };
  const closeError = () => {
    setErrorOpen(false);
  };

  const titleBoxBackgroundColour = '#1976d21a';
  if (loading) {
    return (
      // <div>
      //   Loading...
      // </div>

      <DarkBackground >
        <LoadingOverlay
          active={true}

          spinner={true}
          text="Loading..."
        >
        </LoadingOverlay>
      </DarkBackground>

    )
  } else if (loading === false && error !== null) {
    return (
      <Stack spacing={2}>
        <Alert severity="error">Error occurred loading incidents</Alert>
      </Stack>

    )
  }

  return (
    <Fragment>
      <SuccessError
        successMessage={successMessage}
        closeError={() => closeError()}
        closeSuccess={() => closeSuccess()}
        successOpen={successOpen}
        errorOpen={errorOpen}
      >
      </SuccessError>

      <Box
        component="span"
        m={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h3" component="h2">
          Breach Tracking
        </Typography>

        <Button variant="outlined" onClick={addIncident}>Add Incident</Button>
      </Box>

      <Fragment>

        <div style={{ height: '70vh', width: '100%' }}>
          <DataGrid
            //componentsProps={{ toolbar: { csvOptions: { allColumns: true } } }} 
            fullWidth

            components={{
              Toolbar: CustomToolbar,
            }}
            initialState={{
              pagination: {
                pageSize: 10,
              },
            }}
            height='100%'
            rows={incidentData}
            columns={columns}
            //pageSize={5}
            rowsPerPageOptions={[10, 25]}
          //checkboxSelection
          />

        </div>
        <Dialog open={open} onClose={handleCancel} maxWidth="md" >
          <DialogTitle style={{ paddingTop: "5px", paddingBottom: "5px" }}>
            <Box
              component="span"
              //m={3}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              //border={3}
              sx={{ color: 'text.primary', fontSize: 34, fontWeight: 'medium' }}
            >
              {editOrAddTitle} Incident
            </Box>

          </DialogTitle >
          <form >
            <DialogContent style={{ paddingTop: "5px", paddingBottom: "5px" }}>
              <Fragment>
                <Paper variant="outlined"  >
                  <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                    onClick={() => setGeneralOpen(!generalOpen)}
                  >
                    <Grid container sx={{ justifyContent: "space-between" }} >
                      <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                        Incident Information
                      </Typography>
                      <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                        {generalOpen ? <RemoveIcon /> : <AddIcon />}
                      </Typography>

                    </Grid>
                  </Box>

                  <Collapse in={generalOpen} width={'100%'}>
                    <Box sx={{ border: 1 }} px={1} py={2}>

                      <TextField
                        required
                        id="id"
                        name="id"
                        label="ID"
                        fullWidth
                        hidden
                        margin="dense"
                        {...register('id')}

                      />

                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            required
                            id="incidentTitle"
                            name="incidentTitle"
                            label="Incident Title"
                            fullWidth
                            margin="dense"
                            {...register('incidentTitle')}
                            error={errors.incidentTitle ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.incidentTitle?.message}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} sm={12}>
                          <TextField
                            required
                            id="institutionName"
                            name="institutionName"
                            label="Institution Name"
                            fullWidth
                            margin="dense"
                            {...register('institutionName')}
                            error={errors.institutionName ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.institutionName?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <TextField
                            required
                            id="institutionAddress"
                            name="institutionAddress"
                            label="Institution Address"
                            multiline
                            maxRows={3}
                            fullWidth

                            margin="dense"
                            {...register('institutionAddress')}
                            error={errors.institutionAddress ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.institutionAddress?.message}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={6}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Name of person describing the incident"
                            id="incidentDescriber"
                            name="incidentDescriber"
                            label="Name of person describing the incident"

                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('incidentDescriber')}
                            error={errors.incidentDescriber ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.incidentDescriber?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Describer Title"
                            id="describerTitle"
                            name="describerTitle"
                            label="Title of person describing the incident"

                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('describerTitle')}
                            error={errors.describerTitle ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.describerTitle?.message}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={6}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Contact Phone"
                            id="contactPhone"
                            name="contactPhone"
                            label="Contact Phone"

                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('contactPhone')}
                            error={errors.contactPhone ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.contactPhone?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Contact Mobile"
                            id="contactMobile"
                            name="contactMobile"
                            label="Contact Mobile"

                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('contactMobile')}
                            error={errors.contactMobile ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.contactMobile?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Total # of individuals affected"
                            id="totalAffected"
                            name="totalAffected"
                            label="Total # affected"

                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('totalAffected')}
                            error={errors.totalAffected ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.totalAffected?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Total # of Canadians affected"
                            id="canadiansAffected"
                            name="canadiansAffected"
                            label="Total # Canadians affected"

                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('canadiansAffected')}
                            error={errors.canadiansAffected ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.canadiansAffected?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} >
                          <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                            <DatePicker
                              id="startDate"
                              name="startDate"
                              label="Date of Start of Incident"
                              {...register('startDate')}
                              value={startDate}
                              onChange={(newValue) => {
                                setStartDate(newValue);
                                //console.log(newValue);
                                setValue("startDate", newValue);
                              }}
                              renderInput={(params) => <TextField  {...params} />}
                            />
                          </LocalizationProvider>
                          <Typography variant="inherit" color="error.main">
                            {errors.startDate?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={6} sm={6} >
                          <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                            <DatePicker
                              id="endDate"
                              name="endDate"
                              label="Date of End of Incident"
                              {...register('endDate')}
                              value={endDate}
                              onChange={(newValue) => {
                                setEndDate(newValue);
                                //console.log(newValue);
                                setValue("endDate", newValue);
                              }}
                              renderInput={(params) => <TextField  {...params} />}
                            />
                          </LocalizationProvider>
                          <Typography variant="inherit" color="error.main">
                            {errors.endDate?.message}
                          </Typography>
                        </Grid>

                      </Grid>
                    </Box>
                  </Collapse>
                  <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                    onClick={() => setDescriptionOpen(!descriptionOpen)}
                  >
                    <Grid container sx={{ justifyContent: "space-between" }} >
                      <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                        Incident Description
                      </Typography>
                      <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                        {descriptionOpen ? <RemoveIcon /> : <AddIcon />}
                      </Typography>

                    </Grid>
                  </Box>
                  <Collapse in={descriptionOpen} width={'100%'}>
                    <Box sx={{ border: 1 }} px={1} py={3}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('organizationInvolved')}
                            maxSize={2500}
                            errors={errors.organizationInvolved}
                            register={register}
                            name="organizationInvolved"
                            id="organizationInvolved"
                            label="Organizations Involved"
                            placeholder="Description of all organizations involved in the breach including their role(s) with respect to
                            the personal information in question"

                          ></SelfSizingTextField>

                        </Grid>

                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('howWhyOccured')}
                            maxSize={2500}
                            errors={errors.howWhyOccured}
                            register={register}
                            name="howWhyOccured"
                            id="howWhyOccured"
                            label="How and Why the Breach Occurred"
                            placeholder="How and why the breach occurred (please include some technical detail regarding the breach including an explanation of the methodology of the attack if one took place)"

                          ></SelfSizingTextField>

                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('whenDiscovered')}
                            maxSize={2500}
                            errors={errors.whenDiscovered}
                            register={register}
                            name="whenDiscovered"
                            id="whenDiscovered"
                            label="When the breach was discovered"
                            placeholder="When the breach was discovered"

                          ></SelfSizingTextField>

                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('whereOccured')}
                            maxSize={2500}
                            errors={errors.whereOccured}
                            register={register}
                            name="whereOccurred"
                            id="whereOccurred"
                            label="Where the breach occurred"
                            placeholder="Where the breach occurred"

                          ></SelfSizingTextField>

                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('whoGainedAccess')}
                            maxSize={2500}
                            errors={errors.whoGainedAccess}
                            register={register}
                            name="whoGainedAccess"
                            id="whoGainedAccess"
                            label="Who may have had access"
                            placeholder="Who may have had access to the personal information (to the extent known)"

                          ></SelfSizingTextField>

                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField
                            initialValue={getValues('infoBreachedDescription')}
                            maxSize={2500}
                            errors={errors.infoBreachedDescription}
                            register={register}
                            name="infoBreachedDescription"
                            id="infoBreachedDescription"
                            label="Description of the personal information that was breached"
                            placeholder="Describe the type and nature of the personal information that was breached (for instance, name, phone number, email address, account number, social insurance number, etc.). Please specify if client or employee information was accessed."
                          > </SelfSizingTextField>
                        </Grid>
                        <Grid item xs={6} sm={6} md={6}>
                          <FormControl>
                            <FormLabel id="demo-radio-buttons-group-label">Have affected individuals been notified? </FormLabel>
                            <RadioGroup
                              row
                              aria-labelledby="demo-radio-buttons-group-label"

                              name="radio-buttons-group"
                              {...register('affectedNotified')}
                              onChange={(e) => {
                                //handleBooleanRadioButtonChange(e, affectedNotified);
                                setAffectedNotified(!affectedNotified);
                              }}
                            >
                              {/* <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && !cloudHosted} key='1' value={'1'} checked={cloudHosted} control={<Radio />} label="Yes" />
                              <FormControlLabel {...register('cloudHosted')} disabled={!currentUser.isSuperAdmin && cloudHosted} key='0' value={'0'} checked={cloudHosted === false} control={<Radio />} label="No" /> */}
                              <FormControlLabel {...register('affectedNotified')} key='1' value={affectedNotified} checked={affectedNotified} control={<Radio />} label="Yes" />
                              <FormControlLabel {...register('affectedNotified')} key='0' value={affectedNotified} checked={affectedNotified === false} control={<Radio />} label="No" />

                            </RadioGroup>
                          </FormControl>
                          <Typography variant="inherit" color="error.main">
                            {errors.affectedNotified?.message}
                          </Typography>

                        </Grid>
                        <Grid item xs={8} sm={8} ></Grid>
                        {affectedNotified && (<>
                          <Grid item xs={6} sm={6} >
                            <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                              <DatePicker
                                id="notificationStartDate"
                                name="notificationStartDate"
                                label="Notification Start Date"
                                {...register('notificationStartDate')}
                                value={notificationStartDate}
                                onChange={(newValue) => {
                                  setNotificationStartDate(newValue);
                                  //console.log(newValue);
                                  setValue("notificationStartDate", newValue);
                                }}
                                renderInput={(params) => <TextField  {...params} />}
                              />
                            </LocalizationProvider>
                            <Typography variant="inherit" color="error.main">
                              {errors.notificationStartDate?.message}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} sm={6} >
                            <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                              <DatePicker
                                id="notificationEndDate"
                                name="notificationEndDate"
                                label="Notification End Date"
                                {...register('notificationEndDate')}
                                value={notificationEndDate}
                                onChange={(newValue) => {
                                  setNotificationEndDate(newValue);
                                  //console.log(newValue);
                                  setValue("notificationEndDate", newValue);
                                }}
                                renderInput={(params) => <TextField  {...params} />}
                              />
                            </LocalizationProvider>
                            <Typography variant="inherit" color="error.main">
                              {errors.notificationEndDate?.message}
                            </Typography>
                          </Grid>
                        </>
                        )}
                        <Grid item xs={6} sm={6}  >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            placeholder="Method of notification"
                            id="notificationMethod"
                            name="notificationMethod"
                            label="Method of notification"

                            maxRows={3}
                            fullWidth
                            margin="dense"
                            {...register('notificationMethod')}
                            error={errors.notificationMethod ? true : false}
                          />
                          <Typography variant="inherit" color="error.main">
                            {errors.notificationMethod?.message}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('notificatonDescription')}
                            maxSize={2500}
                            errors={errors.notificatonDescription}
                            register={register}
                            name="notificatonDescription"
                            id="notificatonDescription"
                            label="Notification Form"
                            placeholder="Describe the form of notification: (For example, this can include directly by letter, email, telephone; indirectly via newspaper announcement, etc.)"

                          ></SelfSizingTextField>

                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('notificatonIndirectDescription')}
                            maxSize={2500}
                            errors={errors.notificationIndirectDescription}
                            register={register}
                            name="notificationIndirectDescription"
                            id="notificationIndirectDescription"
                            label="Indirect Notification"
                            placeholder="If you have chosen to notify indirectly, describe the rationale for doing so as well as the type of indirect notification used (i.e. how it was delivered to the target audience)"

                          ></SelfSizingTextField>

                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('notificatonStepsDescription')}
                            maxSize={2500}
                            errors={errors.notificatonStepsDescription}
                            register={register}
                            name="notificatonStepsDescription"
                            id="notificatonStepsDescription"
                            label="Notification Steps"
                            placeholder="Description of any steps (apart from notification to affected individuals) taken by the organization to reduce the risk of harm to affected individuals, or to mitigate that harm: • taking steps such as resetting passwords, offering credit monitoring services where appropriate, recovering misdirected information, seeking confirmation from unintended recipients that they have destroyed and not circulated the information; and • notifying third parties or organizations that can reduce the risk of harm, such as the police, payment processors or credit card companies"

                          ></SelfSizingTextField>

                        </Grid>

                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('notifiedOrganizations')}
                            maxSize={2500}
                            errors={errors.notifiedOrganizations}
                            register={register}
                            name="notifiedOrganizations"
                            id="notifiedOrganizations"
                            label="Notification Organizations"
                            placeholder="Description of any organizations and/or government institutions notified about the breach not mentioned above (for example, professional bodies or other privacy commissioners' offices)"

                          ></SelfSizingTextField>

                        </Grid>

                        <Grid item xs={12} sm={12}>
                          <SelfSizingTextField

                            initialValue={getValues('RiskReductionSteps')}
                            maxSize={2500}
                            errors={errors.riskReductionSteps}
                            register={register}
                            name="riskReductionSteps"
                            id="riskReductionSteps"
                            label="Risk Reduction Steps"
                            placeholder="Description of the steps taken to reduce the risk of a similar event occurring in the future:
                            For example:
                            • an experienced IT security firm has been hired to review the organization's security program and we
                             are committed to making any recommended improvements;
                            • all new contracts with web service providers will include the following quality control provisions ... ,
                            • a privacy training module has been developed and is now mandatory for all staff;
                            • all laptops will be encrypted;
                            • software change management protocol has been updated; etc."
                          ></SelfSizingTextField>

                        </Grid>
                      </Grid>
                    </Box>

                  </Collapse>

                </Paper>
              </Fragment>
            </DialogContent>

            <DialogActions>
              {//vendorData.userAndTenant.isSuperAdmin && 
                <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
              }
              <Button onClick={handleCancel}>Cancel</Button>

            </DialogActions>
          </form>

        </Dialog>

        <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Delete Incident</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to Delete <strong>{deleteName} ?</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDelete}>Delete</Button>
            <Button onClick={handleDeleteCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>

      </Fragment>

    </Fragment>


  );

}